import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from "clsx";
import React from "react";
import { PageContainer } from "./PageContainer";
export function Footer(_param) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, _columns = _param.columns, columns = _columns === void 0 ? {} : _columns, _justifyAround = _param.justifyAround, justifyAround = _justifyAround === void 0 ? false : _justifyAround, _businessName = _param.businessName, businessName = _businessName === void 0 ? "" : _businessName, rest = _object_without_properties(_param, [
        "className",
        "columns",
        "justifyAround",
        "businessName"
    ]);
    return /*#__PURE__*/ _jsx(PageContainer, _object_spread_props(_object_spread({}, rest), {
        children: /*#__PURE__*/ _jsx("div", {
            className: clsx("flex flex-col items-stretch space-y-10 lg:flex-row", "lg:space-x-10 lg:space-y-0 py-14 text-sm", justifyAround ? "justify-around" : "justify-between", className),
            children: Object.keys(columns).map(function(k, i) {
                var col = columns[k];
                return /*#__PURE__*/ _jsxs("div", {
                    className: "min-w-full space-y-6 lg:min-w-0",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "block w-auto font-medium text-left",
                            children: k
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "opacity-60 flex flex-col space-y-3",
                            children: Array.isArray(col) ? col.map(function(x, i) {
                                return /*#__PURE__*/ _jsx("div", {
                                    className: "",
                                    children: x
                                }, i);
                            }) : col
                        })
                    ]
                }, i);
            })
        })
    }));
}
